import { render, staticRenderFns } from "./ReportePage.vue?vue&type=template&id=24f9c662"
import script from "./ReportePage.js?vue&type=script&lang=js&external"
export * from "./ReportePage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports